import { createContext } from 'react';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-ea7cc233-62dc80e0.js';

const FileUploadContext = /*#__PURE__*/createContext({
  description: null,
  disabled: false,
  errorText: '',
  fullWidth: false,
  inputId: '',
  inputRef: null,
  onCloseAlert: noop
});
var FileUploadContext$1 = FileUploadContext;

export { FileUploadContext$1 as F };
//# sourceMappingURL=FileUploadContext-b6adb5c3.js.map
